import styled from 'styled-components'
import { DefaultFontStyle } from '../../../styles/global-styles'
import { Card } from '../../atoms/Card/card-styles'

export const PopupBody = styled.div`
  background: #ffffff;
  width: 100%;
  padding: 21px 30px 30px 30px;
  @media (max-width: ${props => props.theme.breakpoints.md}px) {
    padding: 10px 10px 12px 10px;
  }
  @media (max-height: 280px) {
    padding: 5px;
  }
`

export const PopupBodyNoPadding = styled(PopupBody)`
  padding: 0px;
`

export const PopupCard = styled(Card)`
  ${DefaultFontStyle};
  text-align: center;
  background-color: #fff;
  width: 335px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  padding: 26px;
  p {
    font-family: 'Roboto';
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    max-width: 350px;
  }
  @media (min-width: ${props => props.theme.breakpoints.md}px) {
    width: 488px;
  }

  @media (max-height: 280px) {
    height: 100%;
    max-width: max-content;
    width: max-content;
    padding: 0px 6px 14px 6px;
  }
`

export const Header = styled.h6`
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  text-align: center;
  color: #000000;
  margin: 0px;
  margin-block-end: 15px;
`

export const RedHeader = styled.div`
  font-family: 'Poppins';
  font-weight: 600;
  font-size: 18px;
  text-align: left;
  text-decoration: underline;
  color: ${props => props.theme.colours.darkRed};
  margin: 0px;
  margin-block-end: 15px;
  width: 100%;
  padding: 10px 10px 12px 10px;
  text-underline-offset: 10px;
  text-decoration-thickness: 3px;
`

export const ButtonFlexBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  gap: 25px;
  margin-top: 18px;

  @media (max-width: ${props => props.theme.breakpoints.lg}px) {
    gap: 10px;
    flex-direction: column-reverse;
    margin-top: 0px;
  }
`

export const BookingTypeButtonFlexBox = styled(ButtonFlexBox)`
  &&& {
    gap: 10px;
    margin-top: 36px;
    @media (max-width: ${props => props.theme.breakpoints.lg}px) {
      flex-direction: row;
    }
  }
`

export const ResultIcon = styled.img`
  width: 41px;
  margin-bottom: 7px;
`

export const BookingTypeIcon = styled.img`
  width: ${props => props.width};
  height: ${props => props.height};
  align-self: flex-end;
`

export const PopupText = styled.p`
  font-size: 16px;
  white-space: pre-line;
  @media (max-width: ${props => props.theme.breakpoints.lg}px) {
    margin-top: -10px;
  }
`

export const CentredPopupText = styled(PopupText)`
  &&& {
    max-width: none;
  }
`

export const LoadingContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
  width: 373px;
  @media (max-width: ${props => props.theme.breakpoints.md}px) {
    width: 250px;
  }
`

export const BookingDetailsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`

export const WarnIcon = styled.img`
  width: 70px;
  height: 70px;
  margin-bottom: 7px;
`
